import React from "react";
import { Stack, Text } from "@mantine/core";

const PaymentSection = ({ title, subtitle, children }) => {
  return (
    <Stack gap="md">
      {(title || subtitle) && (
        <div>
          {title && (
            <Text size="lg" fw={600} c="gray.8">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text size="sm" c="dimmed" mt={4}>
              {subtitle}
            </Text>
          )}
        </div>
      )}
      {children}
    </Stack>
  );
};

export default PaymentSection;
